import { createContext } from 'react';

/**
 * Marker context that signals whether the CopilotKit v2 provider is mounted
 * upstream. Set to `true` by `CopilotKitMount` (production path) and read by
 * `ToolCallRenderer` to decide whether to dispatch through the v2 render
 * registry via `useRenderToolCall()` or fall back to direct rendering.
 *
 * Why a separate context: `useRenderToolCall()` calls `useCopilotKit()`, which
 * destructures `copilotkit` from the SDK's own context. The default export of
 * that context has `copilotkit: null`, so the hook throws synchronously when
 * called outside a `<CopilotKitProvider>`. We can't read the SDK's context
 * directly (it isn't part of the v2 public exports — see
 * `node_modules/@copilotkit/react-core/dist/v2/index.d.cts`), so we publish
 * our own boolean from the same mount that wraps the SDK provider. Tests that
 * use the mock runtime (e.g. `chatToolCallChip.test.tsx`) simply omit this
 * provider and `ToolCallRenderer` falls back to direct rendering.
 */
export const ToolCallRegistryAvailable = createContext(false);
